var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 144,
    height: 144,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 23.977,
    y1: 6.159,
    x2: 23.977,
    y2: 42.046,
    gradientUnits: "userSpaceOnUse",
    id: "color-1_fdfLpA6fsXN2_gr1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.004,41.969l-31.973,0.031c-1.099,0.001 -1.999,-0.897 -2,-1.996l-0.031,-31.973c-0.001,-1.099 0.897,-1.999 1.996,-2l31.973,-0.031c1.099,-0.001 1.999,0.897 2,1.996l0.031,31.973c0.001,1.099 -0.897,1.999 -1.996,2z",
    fill: "url(#color-1_fdfLpA6fsXN2_gr1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.208,20.607c1.576,1.126 3.507,1.788 5.592,1.788v-4.011c-0.395,0 -0.788,-0.041 -1.174,-0.123v3.157c-2.085,0 -4.015,-0.663 -5.592,-1.788v8.184c0,4.094 -3.321,7.413 -7.417,7.413c-1.528,0 -2.949,-0.462 -4.129,-1.254c1.347,1.376 3.225,2.23 5.303,2.23c4.096,0 7.417,-3.319 7.417,-7.413v-8.183zM30.657,16.561c-0.805,-0.879 -1.334,-2.016 -1.449,-3.273v-0.516h-1.113c0.28,1.597 1.236,2.962 2.562,3.789zM19.079,30.832c-0.45,-0.59 -0.693,-1.311 -0.692,-2.053c0,-1.873 1.519,-3.391 3.393,-3.391c0.349,0 0.696,0.053 1.029,0.159v-4.1c-0.389,-0.053 -0.781,-0.076 -1.174,-0.068v3.191c-0.333,-0.106 -0.68,-0.159 -1.03,-0.159c-1.874,0 -3.393,1.518 -3.393,3.391c0.001,1.325 0.76,2.472 1.867,3.03z",
    fill: "#ec407a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.034,19.63c1.576,1.126 3.507,1.788 5.592,1.788v-3.157c-1.164,-0.248 -2.194,-0.856 -2.969,-1.701c-1.326,-0.827 -2.281,-2.191 -2.561,-3.788h-2.923v16.018c-0.007,1.867 -1.523,3.379 -3.393,3.379c-1.102,0 -2.081,-0.525 -2.701,-1.338c-1.107,-0.558 -1.866,-1.705 -1.866,-3.029c0,-1.873 1.519,-3.391 3.393,-3.391c0.359,0 0.705,0.056 1.03,0.159v-3.19c-4.024,0.083 -7.26,3.369 -7.26,7.411c0,2.018 0.806,3.847 2.114,5.183c1.18,0.792 2.601,1.254 4.129,1.254c4.096,0 7.417,-3.319 7.417,-7.413l-0.002,-8.185z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.626,18.262v-0.854c-1.05,0.002 -2.078,-0.292 -2.969,-0.848c0.788,0.863 1.826,1.458 2.969,1.702zM28.095,12.772c-0.027,-0.153 -0.047,-0.306 -0.061,-0.461v-0.516h-4.036v16.019c-0.006,1.867 -1.523,3.379 -3.393,3.379c-0.549,0 -1.067,-0.13 -1.526,-0.362c0.62,0.813 1.599,1.338 2.701,1.338c1.87,0 3.386,-1.512 3.393,-3.379v-16.018zM21.635,21.38v-0.909c-0.337,-0.046 -0.677,-0.069 -1.018,-0.069c-4.097,0 -7.417,3.319 -7.417,7.413c0,2.567 1.305,4.829 3.288,6.159c-1.308,-1.336 -2.114,-3.165 -2.114,-5.183c0,-4.042 3.237,-7.328 7.261,-7.411z",
    fill: "#81d4fa",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.b981deb4c2563bd39c0f4e3894992fc8.svg";
export { ForwardRef as ReactComponent };